<template>
  <div>
    <!-- START DATA DIRI -->
    <b-card no-body class="mb-1" v-if="currentUser.info.role_id === 4">
      <b-card-header header-tag="header" class="p-3" role="tab">
        <span class="m-1">Data Badan Hukum</span>
        <b-button v-b-toggle.accordion-34 variant="yellow" class="chevron">
          <span class="when-open">
            <b-icon icon="chevron-up" />
          </span>
          <span class="when-closed">
            <b-icon icon="chevron-down" />
          </span>
        </b-button>
      </b-card-header>

      <b-collapse id="accordion-34" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-alert v-if="sectionRejectionMessages.length > 0" show variant="warning" class="mb-4">
            <b-icon icon="exclamation-triangle-fill" class="mr-2"></b-icon>
            <strong>Informasi Penolakan (Data Badan Hukum):</strong>
            <div v-for="(msg, idx) in sectionRejectionMessages" :key="idx" class="mt-2 ml-4">
              <p class="mb-1"><strong>Alasan:</strong> {{ msg.note }}</p>
              <div v-if="msg.fields && msg.fields.length > 0">
                <p class="mb-0"><strong>Data atau informasi yang memerlukan perbaikan:</strong></p>
                <ol class="mb-2">
                  <li v-for="f in msg.fields" :key="f.field" class="font-weight-bold">{{ f.label }}</li>
                </ol>
              </div>
            </div>
            <hr v-if="sectionRejectionMessages.length > 0">
            <p class="mt-2 mb-0">Untuk dapat melakukan pengajuan kembali mohon dapat memperbarui data badan hukum anda pada kolom yang berwarna merah di bawah ini.</p>
          </b-alert>

          <b-card-text>
            <div class="container">
              <div v-if="isLoading" class="text-center my-4">
                <b-spinner
                  label="Loading..."
                  variant="primary"
                  small
                ></b-spinner>
                <p>Memuat data, mohon tunggu...</p>
              </div>

              <b-form v-else @submit.prevent="confirmChangeData">
                <!-- <b-form @submit.prevent="updateDataBadanHukum"> -->
                <!-- START NAMA LENGKAP -->

                <div class="row">
                  <span style="font-size: 12px">Note : (*) Wajib diisi</span>
                </div>
                <div class="row">
                  <div class="col">
                    <FormInput
                      type="select"
                      label="Jenis Badan Hukum"
                      :options="options.legalEntity"
                      v-model="form.legal_entity_type_id"
                      :required="true"
                      :class="{'is-invalid': allRejectedFields && (allRejectedFields.includes('legal_entity_type_id') || allRejectedFields.includes('legal_entity_id'))}"
                      :label-class="allRejectedFields && (allRejectedFields.includes('legal_entity_type_id') || allRejectedFields.includes('legal_entity_id')) ? 'text-danger font-weight-bold' : ''"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <FormInput
                      type="text"
                      label="Nama Badan Hukum"
                      placeholder="Masukkan Nama Badan Hukum"
                      v-model="form.legal_entity_name"
                      :required="true"
                      :disabled="ekyc_verified"
                      :class="{'is-invalid border-danger': allRejectedFields && (allRejectedFields.includes('legal_entity_name') || allRejectedFields.includes('nama_badan_hukum'))}"
                    />
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <BFormInputWithMask
                      type="number"
                      label="No. Ponsel Badan Hukum"
                      v-model="form.phone"
                      placeholder="Nomor Ponsel Badan Hukum"
                      :class="{'is-invalid border-danger': allRejectedFields && (allRejectedFields.includes('phone') || allRejectedFields.includes('no_handphone'))}"
                      label-class="allRejectedFields && (allRejectedFields.includes('phone') || allRejectedFields.includes('no_handphone')) ? 'text-danger font-weight-bold' : ''"
                      @blur="handleBlur(`phone`)"
                      :callback="
                        () => callbackMasking(`phone`)
                      "
                      :mask="mask.phone"
                      :disabled="mask.phone"
                      :required="true"
                    />
                  </div>
                  <div class="col">
                    <BFormInputWithMask
                      type="email"
                      label="Email Badan Hukum"
                      v-model="form.email"
                      placeholder="Masukkan email"
                      :class="{'is-invalid border-danger': allRejectedFields && allRejectedFields.includes('email')}"
                      label-class="allRejectedFields && allRejectedFields.includes('email') ? 'text-danger font-weight-bold' : ''"
                      @blur="handleBlur(`email`)"
                      :callback="
                        () => callbackMasking(`email`)
                      "
                      :mask="mask.email"
                      :disabled="mask.email"
                      :required="true"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <FormInput
                      type="select"
                      label="Bidang Usaha"
                      :options="options.bussinesField"
                      v-model="form.business_field_id"
                      :required="true"
                      :class="{'is-invalid border-danger': allRejectedFields && (allRejectedFields.includes('business_field_id') || allRejectedFields.includes('bidang_usaha_id'))}"
                      :label-class="allRejectedFields && (allRejectedFields.includes('business_field_id') || allRejectedFields.includes('bidang_usaha_id')) ? 'text-danger font-weight-bold' : ''"
                    />
                  </div>
                  <div class="col mt-3">
                    <BFormInputWithMask
                      type="date"
                      v-model="form.establishment_date"
                      label="Tanggal Didirikan"
                      :required="true"
                      :class="{'is-invalid border-danger': allRejectedFields && allRejectedFields.includes('establishment_date')}"
                      label-class="allRejectedFields && allRejectedFields.includes('establishment_date') ? 'text-danger font-weight-bold' : ''"
                    />
                  </div>
                </div>

                <div class="row">
                  <div class="col mt-3">
                    <BFormInputWithMask
                      type="number"
                      v-model="form.taxpayer_number"
                      placeholder="NPWP"
                      label="NPWP Badan Hukum"
                      :class="{'is-invalid border-danger': allRejectedFields && (allRejectedFields.includes('taxpayer_number') || allRejectedFields.includes('npwp'))}"
                      label-class="allRejectedFields && (allRejectedFields.includes('taxpayer_number') || allRejectedFields.includes('npwp')) ? 'text-danger font-weight-bold' : ''"
                      @blur="handleBlur(`taxpayer_number`)"
                      :callback="() => callbackMasking(`taxpayer_number`)"
                      :mask="mask.taxpayer_number"
                      :disabled="mask.taxpayer_number"
                      :required="true"
                    />
                  </div>
                  <div class="col">
                    <FormInput  
                      type="file"
                      label="NPWP Badan Hukum"
                      :value="photo.taxpayer_document"
                      @input="
                        (val) => {
                          form.taxpayer_document = val;
                          photo.taxpayer_document = val;
                        }
                      "
                      :required="true"
                      :previewFile="form.taxpayer_document_path"
                      :class="{'is-invalid': allRejectedFields && (allRejectedFields.includes('taxpayer_document_path') || allRejectedFields.includes('npwp_attachment'))}"
                      :label-class="allRejectedFields && (allRejectedFields.includes('taxpayer_document_path') || allRejectedFields.includes('npwp_attachment')) ? 'text-danger font-weight-bold' : ''"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col mt-3">
                    <BFormInputWithMask
                      type="number"
                      v-model="form.deed_number"
                      placeholder="Akta Pendirian"
                      label="Akta Pendirian"
                      @blur="handleBlur(`deed_number`)"
                      :callback="() => callbackMasking(`deed_number`)"
                      :mask="mask.deed_number"
                      :disabled="mask.deed_number"
                      :required="true"
                      :class="{'is-invalid border-danger': allRejectedFields && allRejectedFields.includes('deed_number')}"
                      label-class="allRejectedFields && allRejectedFields.includes('deed_number') ? 'text-danger font-weight-bold' : ''"
                    />
                  </div>
                  <div class="col">
                    <FormInput
                      type="file"
                      label="Akta Pendirian"
                      :value="photo.deed_document"
                      @input="
                        (val) => {
                          form.deed_document = val;
                          photo.deed_document = val;
                        }
                      "
                      :required="true"
                      :previewFile="form.deed_document_path"
                      :class="{'is-invalid': allRejectedFields && allRejectedFields.includes('deed_document_path')}"
                      :label-class="allRejectedFields && allRejectedFields.includes('deed_document_path') ? 'text-danger font-weight-bold' : ''"
                    />
                  </div>
                </div>

                <div class="row">
                  <div class="col mt-3">
                    <BFormInputWithMask
                      type="number"
                      label="Nomor Akta Perubahan Terakhir"
                      v-model="form.latest_deed_number"
                      placeholder="Nomor Akta Perubahan Terakhir"
                      @blur="handleBlur(`latest_deed_number`)"
                      :callback="() => callbackMasking(`latest_deed_number`)"
                      :mask="mask.latest_deed_number"
                      :disabled="mask.latest_deed_number"
                      :class="{'is-invalid border-danger': allRejectedFields && allRejectedFields.includes('latest_deed_number')}"
                      label-class="allRejectedFields && allRejectedFields.includes('latest_deed_number') ? 'text-danger font-weight-bold' : ''"
                    />
                  </div>
                  <div class="col">
                    <FormInput
                      type="file"
                      label="Akta Perubahan Terakhir"
                      :value="photo.latest_deed_document"
                      @input="
                        (val) => {
                          form.latest_deed_document = val;
                          photo.latest_deed_document = val;
                        }
                      "
                      :previewFile="form.latest_deed_document_path"
                    />
                  </div>
                </div>
                <!-- SK Kemenkumham Pendirian -->
                <div class="row">
                  <div class="col mt-3">
                    <BFormInputWithMask
                      type="number"
                      label="SK Kemenkumham Pendirian"
                      v-model="form.establishment_menkumham_number"
                      placeholder="Nomor SK Kemenkumham Pendirian"
                      @blur="handleBlur(`establishment_menkumham_number`)"
                      :callback="
                        () => callbackMasking(`establishment_menkumham_number`)
                      "
                      :mask="mask.establishment_menkumham_number"
                      :disabled="mask.establishment_menkumham_number"
                    />
                  </div>
                  <div class="col">
                    <FormInput
                      type="file"
                      label="SK Kemenkumham Pendirian"
                      :value="photo.establishment_menkumham_document"
                      @input="
                        (val) => {
                          form.establishment_menkumham_document = val;
                          photo.establishment_menkumham_document = val;
                        }
                      "
                      :required="true"
                      :previewFile="form.establishment_menkumham_document_path"
                    />
                  </div>
                </div>

                <!-- SK Kemenkumham Perubahan Terakhir -->
                <div class="row">
                  <div class="col mt-3">
                    <BFormInputWithMask
                      type="number"
                      label="SK Kemenkumham Perubahan Terakhir"
                      v-model="form.latest_menkumham_number"
                      placeholder="SK Kemenkumham Perubahan Terakhir"
                      @blur="handleBlur(`latest_menkumham_number`)"
                      :callback="
                        () => callbackMasking(`latest_menkumham_number`)
                      "
                      :mask="mask.latest_menkumham_number"
                      :disabled="mask.latest_menkumham_number"
                    />
                  </div>
                  <div class="col">
                    <FormInput
                      type="file"
                      label="SK Kemenkumham Perubahan Terakhir"
                      :value="photo.latest_menkumham_document"
                      @input="
                        (val) => {
                          form.latest_menkumham_document = val;
                          photo.latest_menkumham_document = val;
                        }
                      "
                      :previewFile="form.latest_menkumham_document_path"
                    />
                  </div>
                </div>

                <!-- NIB -->
                <div class="row">
                  <div class="col mt-3">
                    <BFormInputWithMask
                      type="number"
                      label="Nomor Induk Berusaha (NIB)"
                      v-model="form.business_identification_number"
                      placeholder="Nomor Induk Berusaha"
                      @blur="handleBlur(`business_identification_number`)"
                      :callback="
                        () => callbackMasking(`business_identification_number`)
                      "
                      :mask="mask.business_identification_number"
                      :disabled="mask.business_identification_number"
                    />
                  </div>
                  <div class="col">
                    <FormInput
                      type="file"
                      label="Nomor Induk Berusaha (NIB)"
                      :value="photo.business_identification_document"
                      @input="
                        (val) => {
                          form.business_identification_document = val;
                          photo.business_identification_document = val;
                        }
                      "
                      :required="true"
                      :previewFile="form.business_identification_document_path"
                      :class="{'is-invalid': allRejectedFields && allRejectedFields.includes('business_identification_document_path')}"
                      :label-class="allRejectedFields && allRejectedFields.includes('business_identification_document_path') ? 'text-danger font-weight-bold' : ''"
                    />
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <FormInput
                      type="select"
                      label="Tujuan Pembukaan Rekening"
                      v-model="form.account_opening_purpose_id"
                      :options="options.accountOpeningPurpose"
                      :required="true"
                    />
                  </div>
                  <div class="col">
                    <FormInput
                      type="select"
                      label="Sumber Dana"
                      v-model="form.fund_source_id"
                      :options="options.fundSource"
                      :required="true"
                    />
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <FormInput
                      type="select"
                      label="Perkiraan Nilai Transaksi dalam 1 Tahun"
                      v-model="form.estimated_transaction_value_id"
                      :options="options.estimatedTransaction"
                      :required="true"
                    />
                  </div>
                </div>

                <!-- START ALAMAT KTP -->
                <div class="row">
                  <div class="col">
                    <div class="email mt-3">
                      <label for="alamat-ktp" :class="{'text-danger font-weight-bold': allRejectedFields && (allRejectedFields.includes('address') || allRejectedFields.includes('alamat') || allRejectedFields.includes('identity_address'))}">Alamat Badan Hukum *</label>
                      <br />
                      <BFormInputWithMask
                        type="text"
                        v-model="form.address"
                        placeholder="Masukan alamat sesuai KTP"
                        :class="{'is-invalid border-danger': allRejectedFields && (allRejectedFields.includes('address') || allRejectedFields.includes('alamat') || allRejectedFields.includes('identity_address'))}"
                        @blur="handleBlur(`address`)"
                        :callback="() => callbackMasking(`address`)"
                        :mask="mask.address"
                        :disabled="mask.address"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="provinsi">Provinsi *</label>
                      <br />
                      <b-form-select
                        v-model="form.province_id"
                        :options="options.provinsi"
                        @input="provinsiChange"
                        required
                      ></b-form-select>
                    </div>
                  </div>
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="kota">Kota / Kabupaten *</label>
                      <br />
                      <b-form-select
                        v-model="form.city_id"
                        :options="options.kota"
                        @input="kotaChange"
                        required
                        :disabled="loadingchangeProvince"
                      ></b-form-select>
                      <small
                        v-if="loadingchangeProvince"
                        class="text-muted d-block mt-1"
                        style="font-size: 11px"
                      >
                        <b-spinner
                          small
                          type="grow"
                          class="mr-1"
                          style="width: 0.8rem; height: 0.8rem"
                        ></b-spinner>
                        memuat data kota...
                      </small>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="kecamatan">Kecamatan *</label>
                      <br />
                      <b-form-select
                        v-model="form.district_id"
                        :options="options.kecamatan"
                        @input="kecamatanChange"
                        required
                        :disabled="loadingKotaChange"
                      ></b-form-select>
                      <small
                        v-if="loadingKotaChange"
                        class="text-muted d-block mt-1"
                        style="font-size: 11px"
                      >
                        <b-spinner
                          small
                          type="grow"
                          class="mr-1"
                          style="width: 0.8rem; height: 0.8rem"
                        ></b-spinner>
                        memuat data kecamatan...
                      </small>
                    </div>
                  </div>
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="desa">Desa / Kelurahan *</label>
                      <br />
                      <b-form-select
                        v-model="form.sub_district_id"
                        :options="options.kelurahan"
                        required
                        :disabled="loadingKecamatanChange"
                      ></b-form-select>
                      <small
                        v-if="loadingKecamatanChange"
                        class="text-muted d-block mt-1"
                        style="font-size: 11px"
                      >
                        <b-spinner
                          small
                          type="grow"
                          class="mr-1"
                          style="width: 0.8rem; height: 0.8rem"
                        ></b-spinner>
                        memuat data kelurahan...
                      </small>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <FormInput
                      type="number"
                      label="Kode Pos"
                      v-model="form.postal_code"
                      placeholder="Kode Pos"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="negara">Negara *</label>
                      <br />
                      <b-form-input
                        type="text"
                        v-model="form.country"
                        placeholder="Masukan negara"
                        required
                        :class="{'is-invalid': allRejectedFields && allRejectedFields.includes('country')}"
                      ></b-form-input>
                    </div>
                  </div>
                </div>
                <!-- END ALAMAT KTP -->

                <!-- START TOMBOL SIMPAN -->
                <div class="row">
                  <div class="col">
                    <div class="alamat mt-4">
                      <button
                        type="submit"
                        class="btn btn-f-blue text-white mr-md-2 mr-auto px-4 rounded-0"
                      >
                        <template v-if="isLoading">
                          <b-spinner
                            small
                            type="border"
                            variant="light"
                            class="mr-2"
                            label="Memproses..."
                          ></b-spinner>
                          Memproses...
                        </template>
                        <template v-else>
                          {{ isUpdate === true ? "Ubah Data" : "Kirim Data" }}
                        </template>
                      </button>
                    </div>
                  </div>
                </div>
                <!-- END TOMBOL SIMPAN -->
              </b-form>
            </div>
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>
    <NewCustomModal
      :visible="confirmUpdateModal"
      size="medium"
      @close="closeModalProperly"
    >
      <div
        class="flex-column"
        style="align-items: center; justify-content: center; text-align: center"
      >
        <img
          :src="require(`@/assets/images/landing_page/logo-efunding.svg`)"
          alt="logo"
          width="350"
        />

        <span
          class="title-modal"
          style="font-weight: 700; margin-top: 20px; font-size: 30px"
          >{{
            isUpdate === false
              ? "Konfirmasi Pengisian Data"
              : "Konfirmasi Perubahan"
          }}</span
        >

        <div
          style="
            background-color: #f2f2f2;
            padding: 20px;
            border-radius: 10px;
            margin-top: 30px;
            width: 100%;
            max-width: 500px;
          "
        >
          <div class="text-value" style="color: #274c8e">
            Apakah Anda Yakin untuk melakukan
            {{ isUpdate === true ? "Perubahan" : "Pengiriman" }} data ini
          </div>
        </div>

        <div class="modal-action-buttons no-rekening">
          <button
            class="custom-btn danger"
            @click="closeModalProperly"
            :disabled="isLoading"
          >
            Batal
          </button>
          <button
            class="custom-btn primary d-flex align-items-center justify-content-center"
            @click="updateDataBadanHukum"
            :disabled="isLoading"
          >
            <template v-if="isLoading">
              <b-spinner
                small
                type="border"
                variant="light"
                class="mr-2"
                label="Memproses..."
              ></b-spinner>
              Memproses...
            </template>
            <template v-else> Yakin </template>
          </button>
        </div>
      </div>
    </NewCustomModal>
    <NewCustomModal
      :visible="statusChangeModal"
      size="medium"
      @close="closeModalProperly"
    >
      <div
        class="flex-column"
        style="align-items: center; justify-content: center; text-align: center"
      >
        <img
          :src="require(`@/assets/images/landing_page/logo-efunding.svg`)"
          alt="logo"
          width="350"
        />

        <span
          class="title-modal"
          style="font-weight: 700; margin-top: 20px; font-size: 30px"
          >{{
            isUpdate === false
              ? "Konfirmasi Pengisian Data"
              : "Konfirmasi Perubahan"
          }}</span
        >

        <div
          style="
            background-color: #f2f2f2;
            padding: 20px;
            border-radius: 10px;
            margin-top: 30px;
            width: 100%;
            max-width: 500px;
          "
        >
          <div class="text-value" style="color: #274c8e">
            Apakah Anda Yakin untuk melakukan
            {{ isUpdate === true ? "Perubahan" : "Pengiriman" }} data ini
          </div>
        </div>

        <div class="modal-action-buttons no-rekening">
          <button
            class="custom-btn danger"
            @click="closeModalProperly"
            :disabled="isLoading"
          >
            Batal
          </button>
          <button
            class="custom-btn primary d-flex align-items-center justify-content-center"
            @click="updateDataBadanHukum"
            :disabled="isLoading"
          >
            <template v-if="isLoading">
              <b-spinner
                small
                type="border"
                variant="light"
                class="mr-2"
                label="Memproses..."
              ></b-spinner>
              Memproses...
            </template>
            <template v-else> Yakin </template>
          </button>
        </div>
      </div>
    </NewCustomModal>
    <newCustomModal :visible="statusChangeModal" size="medium">
      <div
        class="flex-column"
        style="align-items: center; justify-content: center; text-align: center"
      >
        <img
          :src="
            statusResponse === 'success'
              ? require('@/assets/images/success-icon.png')
              : require('@/assets/images/wrong-icon.png')
          "
          alt="logo"
          width="200"
        />
        <span
          :style="{
            fontWeight: '700',
            marginTop: '20px',
            fontSize: '30px',
            marginBottom: '40px',
            color: statusResponse === 'success' ? 'green' : 'red',
          }"
        >
          {{ statusResponse === "success" ? "Berhasil" : "Gagal" }}
        </span>
        <div
          :style="{
            backgroundColor:
              statusResponse === 'success' ? '#e7f8ec' : '#f2f2f2',
            padding: '20px',
            borderRadius: '10px',
            width: '100%',
            maxWidth: '500px',
          }"
        >
          <span
            :style="{ color: statusResponse === 'success' ? 'green' : 'red' }"
            >{{ messageResponse }}</span
          >
        </div>
        <div class="modal-action-buttons wrong-modal" style="margin-top: 30px">
          <button
            class="custom-btn"
            :class="statusResponse === 'success' ? 'success' : 'danger'"
            :key="$route.fullPath"
            @click="closeModalstatusResponse"
            :disabled="isLoading"
          >
            Tutup
          </button>
        </div>
      </div>
    </newCustomModal>
  </div>
</template>

<script>
import UserProfile from "../../api/userprofile.js";
import Corporate from "../../api/corporate/corporate.js";

import DataUsaha from "./DataUsaha";
import DataPekerjaan from "./DataPekerjaan";
import AkunBank from "./AkunBank";
import ChangePassword from "./ChangePassword";
import VerifikasiEmail from "./VerifikasiEmail";

// Vue Camera Library
import EasyCamera from "easy-vue-camera";

import FormInput from "./FormInput.vue";
import NewCustomModal from "../newCustomModal.vue";
import Sumberdana from "../../api/sumberdana.js";
import EstimasiTransaksi from "../../api/estimasitransaksi.js";
import BFormInputWithMask from "../../components/masking-input.vue";

export default {
  name: "Profile",
  components: {
    DataPekerjaan,
    DataUsaha,
    AkunBank,
    ChangePassword,
    VerifikasiEmail,
    "v-easy-camera": EasyCamera,
    FormInput,
    NewCustomModal,
    BFormInputWithMask,
  },
  props: {
    allRejectedFields: {
      type: Array,
      default: () => []
    },
    rejectionMessages: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    sectionRejectionMessages() {
      if (!this.rejectionMessages) return [];
      
      return this.rejectionMessages.map(msg => {
        const filteredFields = msg.fields ? msg.fields.filter(f => {
          const model = (f.model || '').trim().toLowerCase();
          return model === 'databadanhukum';
        }) : [];

        if (filteredFields.length > 0) {
          return {
            note: msg.note,
            fields: filteredFields
          };
        }
        return null;
      }).filter(msg => msg !== null);
    }
  },
  data() {
    return {
      loading: false,
      photo: {
        taxpayer_document: null,
        deed_document: null,
        latest_deed_number: null,
        establishment_menkumham_document: null,
        latest_menkumham_document: null,
        business_identification_document: null,
        latest_deed_document: null,
      },
      form: {
        legal_entity_type_id: null,
        legal_entity_name: null,
        phone: null,
        email: null,
        business_field_id: null,
        establishment_date: null,
        taxpayer_number: null,
        taxpayer_document: null,
        deed_number: null,
        deed_document: null,
        latest_deed_document: null,
        latest_deed_number: null,
        establishment_menkumham_number: null,
        establishment_menkumham_document: null,
        establishment_menkumham_document_path: null,
        latest_menkumham_number: null,
        latest_menkumham_document: null,
        business_identification_number: null,
        business_identification_document: null,
        account_opening_purpose_id: null,
        fund_source_id: null,
        address: null,
        province_id: null,
        postal_code: null,
        country: null,
      },
      formSnapshot: {},
      mask: {
        address: true,
        deed_number: true,
        latest_deed_number: true,
        email: true,
        business_identification_number: true,
        phone: true,
        taxpayer_number: true,
        establishment_menkumham_number: true,
        latest_menkumham_number: true,
      },
      options: {
        provinsi: [],
        kota: [],
        kecamatan: [],
        kelurahan: [],

        legalEntity: [],
        bussinesField: [],
        accountOpeningPurpose: [],
        fundSource: [],
        estimatedTransaction: [],
      },
      successModal: false,
      confirmProfileModal: false,
      modalText: "",
      ekyc_verified: false,

      //modals
      confirmUpdateModal: false,
      statusChangeModal: false,

      //var
      isUpdate: null,
      isLoading: false,
      statusResponse: null,
      messageResponse: null,

      //loadings
      loadingKecamatanChange: false,
    };
  },
  watch: {
    form: {
      handler(newVal) {
        if (this.isLoading || !this.formSnapshot) return;
        
        // Loop through rejected fields to see if any were modified
        this.allRejectedFields.forEach(field => {
          if (newVal[field] !== this.formSnapshot[field]) {
            this.$emit('dirty', field);
          }
        });
        
        // Update snapshot
        this.formSnapshot = JSON.parse(JSON.stringify(newVal));
      },
      deep: true
    }
  },
  mounted() {
    this.loadData();
    // this.statusChangeModal = true;
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  methods: {
    async loadData() {
      this.isLoading = true; // mulai loading

      try {
        // Get corporate detail
        const resCorporate = await Corporate.getCorporateDetail();
        if (resCorporate.data.meta.code === 200) {
          let dataCorporate = resCorporate.data.data;
          if (dataCorporate != null) {
            this.isUpdate = true;
          }
          if (dataCorporate.establishment_date) {
            dataCorporate.establishment_date =
              dataCorporate.establishment_date.split(" ")[0];
          }
          Object.assign(this.form, dataCorporate);
          if (this.form.province_id) {
            await this.provinsiChange();
          }
          if (this.form.city_id) {
            await this.kotaChange();
          }
          if (this.form.district_id) {
            await this.kecamatanChange();
          }
          // console.log('establishment_date:', this.form);
        }

        // Get provinsi
        const res = await this.$getListWilayah("provinsi");
        const provinsiArray = res.data || [];
        const arrData = provinsiArray.map((item) => ({
          value: item.id,
          text: item.name,
        }));
        this.options.provinsi = arrData;

        // Dropdowns lainnya
        const [
          resLegalEntity,
          resBusinessField,
          resTujuan,
          resSumberDana,
          resPerkiraan,
        ] = await Promise.all([
          Corporate.dropdownLegalEntityIndex(),
          Corporate.dropdownBusinessField(),
          Corporate.dropdownTujuanPembukaan(),
          Sumberdana.indexV3(),
          EstimasiTransaksi.indexV3("corporate"),
        ]);

        this.options.legalEntity = resLegalEntity.data.data.map((item) => ({
          value: item.id,
          text: item.name,
        }));

        this.options.bussinesField = resBusinessField.data.data.map((item) => ({
          value: item.id,
          text: item.name,
        }));

        this.options.accountOpeningPurpose = resTujuan.data.data.map(
          (item) => ({
            value: item.id,
            text: item.name,
          })
        );

        this.options.fundSource = resSumberDana.data.data.map((item) => ({
          value: item.id,
          text: item.name,
        }));

        this.options.estimatedTransaction = resPerkiraan.data.data.map(
          (item) => ({
            value: item.id,
            text: item.name,
          })
        );
        // Normalize this.form to handle null/undefined as empty strings for consistent comparison
        Object.keys(this.form).forEach(key => {
          if (this.form[key] === null || this.form[key] === undefined) {
            this.form[key] = "";
          }
        });
        this.formSnapshot = JSON.parse(JSON.stringify(this.form));
      } catch (error) {
        console.error("Error in loadData:", error);
      } finally {
        this.isLoading = false; // selesai loading
      }
    },

    async provinsiChange() {
      this.loadingchangeProvince = true;
      try {
        const responseKota = await this.$getListWilayah(
          "kota",
          this.form.province_id
        );
        const kotaArray = responseKota.data || [];
        const arrData = kotaArray.map((item) => ({
          value: item.id,
          text: item.name,
        }));
        this.options.kota = arrData;
      } catch (error) {
        console.error("Error in provinsiChangeKtp:", error);
      } finally {
        this.loadingchangeProvince = false;
      }
    },

    async kotaChange() {
      this.loadingKotaChange = true;
      try {
        const responseKecamatan = await this.$getListWilayah(
          "kecamatan",
          this.form.city_id
        );
        const kecamatanArray = responseKecamatan.data || [];
        const arrData = kecamatanArray.map((item) => ({
          value: item.id,
          text: item.name,
        }));
        this.options.kecamatan = arrData;
      } catch (error) {
        console.error("Error in provinsiChangeKtp:", error);
      } finally {
        this.loadingKotaChange = false;
      }
    },

    async kecamatanChange() {
      this.loadingKecamatanChange = true;
      try {
        const responseKelurahan = await this.$getListWilayah(
          "kelurahan",
          this.form.district_id
        );
        const kelurahanArray = responseKelurahan.data || [];
        const arrData = kelurahanArray.map((item) => ({
          value: item.id,
          text: item.name,
        }));
        this.options.kelurahan = arrData;
      } catch (error) {
        console.error("Error in provinsiChangeKtp:", error);
      } finally {
        this.loadingKecamatanChange = false;
      }
    },

    validatePhoneNumber() {
      const regex = /^62[0-9]{9,14}$/;
      this.errors.no_handphone = "";

      if (!this.form.no_handphone) {
        this.errors.no_handphone = "Nomor handphone tidak boleh kosong.";
      } else if (isNaN(this.form.no_handphone)) {
        this.errors.no_handphone =
          "Nomor handphone hanya boleh mengandung angka.";
      } else if (!regex.test(this.form.no_handphone)) {
        this.errors.no_handphone =
          "Nomor handphone harus diawali dengan '62' dan terdiri dari 9-14 digit angka.";
      }
    },
    validateNomorTandaPengenal() {
      this.errors.nomor_tanda_pengenal = "";

      if (this.form.jenis_tanda_pengenal == "ktp") {
        const nomorTandaPengenal = this.form.nomor_tanda_pengenal.toString();
        if (nomorTandaPengenal.length != 16) {
          this.errors.nomor_tanda_pengenal =
            "Nomor Tanda Pengenal KTP harus 16 angka.";
          return false;
        } else {
          this.errors.nomor_tanda_pengenal = "";
        }
      }
      return true;
    },
    confirmChangeData() {
      this.isLoading = true;
      this.confirmUpdateModal = true;
      this.isLoading = false;
    },
    async updateDataBadanHukum() {
      this.isLoading = true;
      // console.log("forms submit:", this.form);

      const cleanedForm = Object.fromEntries(
        Object.entries(this.form).filter(
          ([_, value]) => value !== null && value !== undefined && value !== ""
        )
      );

      try {
        const res = await Corporate.updateCorporateData(cleanedForm);
        if (res.data.meta.code === 200) {
          this.confirmUpdateModal = false;
          this.statusChangeModal = true;
          this.statusResponse = "success";
          if (this.isUpdate === true) {
            this.messageResponse = "Berhasil Mengubah Data";
          } else {
            this.messageResponse = "Berhasil Mengirim Data";
          }
          this.isLoading = false;
          this.$emit('updated');
        } else {
          this.messageResponse = res.data.meta.message;
          this.isLoading = false;
        }
        // console.log("✅ response update corporate:", res.data.meta.code);
      } catch (err) {
        console.error("❌ Gagal update corporate:", err.response.data || err);
      }

      this.isLoading = false;
    },

    confirmUpdateProfile() {
      this.loading = true;
      UserProfile.update(this.form)
        .then((res) => {
          this.loading = false;
          if (res.data.meta.code == 200) {
            this.modalText = "Data diri berhasil diubah";
            this.confirmProfileModal = false;
            this.successModal = true;
            this.loadData();
          } else {
            console.log(res.data);
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },

    blobToBase64(blob) {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      return new Promise((resolve) => {
        reader.onloadend = () => {
          resolve(reader.result);
        };
      });
    },

    handleCaptureCamera() {
      this.$refs.camera.snap();
      this.photo[this.cameraType] = "";
      setTimeout(() => {
        this.blobToBase64(this.picture).then((res) => {
          if (this.cameraType === "ktp") {
            this.photo.ktp = res;
          } else if (this.cameraType === "selfie") {
            this.photo.selfie = res;
          }
        });
        this.processFile(this.picture);
      }, 1000);
    },

    processFile(blob) {
      // read the files
      var reader = new FileReader();

      if (blob instanceof Blob) {
        reader.readAsArrayBuffer(blob);
        let vm = this;

        reader.onload = function (event) {
          // blob stuff
          var blob = new Blob([event.target.result]); // create blob...
          window.URL = window.URL || window.webkitURL;

          var blobURL = window.URL.createObjectURL(blob); // and get it's URL

          // helper Image object
          var image = new Image();
          image.src = blobURL;
          image.onload = function () {
            // have to wait till it's loaded
            var canvas = document.createElement("canvas");
            var width = image.width;
            var height = image.height;

            // calculate the width and height, constraining the proportions
            if (width > height) {
              if (width > 100) {
                //height *= max_width / width;
                height = 650;
              }
            } else {
              if (height > 100) {
                //width *= max_height / height;
                width = 490;
              }
            }

            // resize the canvas and draw the image data into it
            canvas.width = width;
            canvas.height = height;
            var ctx = canvas.getContext("2d");
            ctx.drawImage(image, 0, 0, width, height);

            canvas.toBlob(async function (blob) {
              // console.log("width", width);
              // console.log("height", height);
              vm.blobToBase64(blob).then((res) => {
                if (vm.cameraType === "ktp") {
                  vm.form.foto_ktp = res;
                } else if (vm.cameraType === "selfie") {
                  vm.form.foto_selfie = res;
                }
              });
              vm.showModalCamera = false;
            });
          };
        };
      } else {
        console.log(this.picture);
      }
    },

    isPDF(file) {
      // Jika file berupa base64, periksa prefixnya
      if (file.startsWith("data:application/pdf")) return true;
      // Jika file berupa path, cek ekstensi file-nya
      const ext = file.split(".").pop().toLowerCase();
      return ext === "pdf";
    },

    handleFileUpload(event, fieldName) {
      const file = event.target.files[0];
      if (!file) return;

      // Validasi tipe file
      if (
        !(file.type.startsWith("image/") || file.type === "application/pdf")
      ) {
        alert("File harus berupa gambar atau PDF.");
        event.target.value = null;
        return;
      }

      // Konversi ke base64 (untuk preview)
      const reader = new FileReader();
      reader.onload = (e) => {
        this.form[fieldName] = e.target.result;
        this.photo[fieldName] = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    closeModalProperly() {
      this.confirmUpdateModal = false;
      this.isLoading = false;
      this.statusChangeModal = false;
    },
    closeModalstatusResponse() {
      window.location.href = "/pengajuan-saya?q=Profil";
    },
    handleBlur(formName) {
      this.mask[formName] = !this.mask[formName];
    },
    callbackMasking(formName) {
      this.mask[formName] = !this.mask[formName];
      return this.mask[formName];
    },
  },
};
</script>

<style scoped>
.collapsed .when-open {
  display: none;
}

.not-collapsed .when-closed {
  display: none;
}

.kyc-image {
  width: 100%;
  height: auto;
  padding: 0 !important;
  object-fit: cover;
}
.flex-column {
  display: flex;
  flex-direction: column;
}
.title-modal {
  font-size: 20px;
  color: #274c8e;
  font-weight: 500;
}
.modal-action-buttons {
  display: flex;
  justify-content: space-between; /* Rata tengah */
  width: 100%;
  gap: 20px; /* Jarak antar tombol */
  margin-top: 20px;
  padding: 0 90px;
}
.modal-action-buttons.no-rekening {
  display: flex;
  justify-content: space-between; /* Rata tengah */
  width: 100%;
  gap: 20px; /* Jarak antar tombol */
  margin-top: 20px;
  padding: 0 60px;
}
.custom-btn {
  background-color: #00a1ca;
  color: white !important;
  padding: 1rem 2rem !important;
  border: none !important;
  border-radius: 8px !important;
  font-weight: 500;
  cursor: pointer;
  min-width: 120px;
  text-align: center;
  font-size: 20px !important;
  transition: background-color 0.3s ease;
}
.custom-btn.primary:disabled,
.custom-btn.primary[disabled] {
  background-color: #cccccc !important;
  color: #666666 !important;
  cursor: not-allowed !important;
  opacity: 0.8;
}
.custom-btn.danger:disabled,
.custom-btn.danger[disabled] {
  background-color: #cccccc !important;
  color: #666666 !important;
  cursor: not-allowed !important;
  opacity: 0.8;
}
.modal-action-buttons.wrong-modal {
  display: flex;
  justify-content: center; /* Rata tengah */
  width: 100%;
  gap: 20px; /* Jarak antar tombol */
  margin-top: 20px;
  padding: 0 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/pengajuan-saya/dataBadanHukum.vue